import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { IconButton } from 'ksnm-common-ui/lib/IconButton';

import { DesignLayout } from '@common/DesignLayout';
import { cmApi } from '@src/api';
import { usePermission } from '@src/utils/hooks/usePermission';
import { auditStore } from '@stores/auditStore';
import { settingUserRolesStore } from '@stores/settingUserRolesStore';
import type { OrganizationDto } from '@src/api';
import type { ReportGroupsDtoDefId } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';

import { UserSettings } from './UserSetting';

import styles from './SettingUserRoles.module.scss';

export const SettingUserRoles = observer(() => {
  const { getUserFilters, userFilter, processUserFilters } = settingUserRolesStore;

  const [groups, setGroups] = useState<ReportGroupsDtoDefId[]>([]);
  const [organizations, setOrganizations] = useState<OrganizationDto[]>([]);
  const [isDirty, setIsDirty] = useState<boolean>(false);

  const permissionUserDataFilter = usePermission('CmUserDataFilter');

  useEffect(() => {
    auditStore.createAuditData({
      moduleName: 'System',
      serviceName: 'Properties',
      operationName: 'View_user_filter_properties',
      message: `Просмотр раздела "Настройка ролей пользователей"`,
    });
  }, []);

  useEffect(() => {
    cmApi.admin.getAdminReportGroups().then(({ data }) => {
      if (data) setGroups(data.map((item) => ({ ...item, id: item.code })));
    });
  }, [permissionUserDataFilter.VIEW]);

  useEffect(() => {
    cmApi.admin.getAdminOrganizations().then(({ data }) => {
      if (data) setOrganizations(data.map((item) => ({ ...item, id: item.code })));
    });
  }, []);

  useEffect(() => {
    getUserFilters();
  }, [getUserFilters]);

  const onSave = useCallback(async () => {
    await processUserFilters();
    setIsDirty(false);
  }, [processUserFilters]);

  return (
    <DesignLayout title="Настройка ролей пользователей">
      <div className={styles.table}>
        <IconButton iconName="save" onClick={onSave} extendClass={styles.button} disabled={!isDirty} />

        <div className={styles.row}>
          <div className={cm(styles.title, styles.cell)}>Имя пользователя</div>
          <div className={cm(styles.title, styles.cell)}>Логин</div>
          <div className={cm(styles.title, styles.cell)}>По организации</div>
          <div className={cm(styles.title, styles.cell)}>По группам отчетов</div>
        </div>

        <div className={styles.body}>
          {userFilter.map((item) => (
            <UserSettings
              key={item.id}
              settings={item}
              organizations={organizations}
              groups={groups}
              setIsDirty={setIsDirty}
            />
          ))}
        </div>
      </div>
    </DesignLayout>
  );
});
